import React, { useState } from "react";
// components
import Iconify from "../components/Iconify";
import HeadingAnimate from "../components/animate/HeadingAnimate";
import AnimatedLottie from "../components/Lottie";
import { Carousel, Card } from "../components/education/Carousel";
import ListItem from "../components/skills/ListItem";
import LoadAnimate from "../components/animate/LoadAnimate";
import educationAnimationData from "../mock/lottie/education.json";
// mocks

// ----------------------------------------------------------------------

export default function Education() {
  return (
    <>
      <div id="education" />
      <div
        className="bg-blend-overlay bg-cover bg-fixed bg-center"
        style={{ backgroundImage: `url('/assets/backImg/bg1.jpg')` }}
      >
        <section className="container mx-auto pt-12 text-center sm:pt-20 ">
          <h2 className="text-center font-lato text-3xl font-semibold text-primary-700 dark:text-cyan-400 sm:text-5xl">
            EDUCATION
          </h2>
          <LoadAnimate amount={0}>
            <div className="container mx-auto py-8 flex flex-col items-center p-5  md:flex-row-reverse">
              {/* <div className="w-auto">
              <AnimatedLottie animationDataFile={educationAnimationData} />
            </div> */}
              <div className="flex-none text-center md:w-full md:items-start md:pl-16 md:text-left lg:flex-none lg:pl-24">
                <h1 className="mb-4 text-xl font-semibold tracking-wide text-primary-700 dark:text-primary-300 sm:text-2xl">
                  Prairie View A&M University
                </h1>
                <div className="gap-10 xl:flex">
                  <div className="mb-2 flex gap-2 text-[#c1d1e7]">
                    <Iconify
                      classes="text-xl"
                      icon={"material-symbols:calendar-month"}
                    />
                    08/2012 - 11/2016
                  </div>
                  <div className="mb-2 flex gap-2 text-[#c1d1e7]">
                    <Iconify
                      classes="text-xl"
                      icon={"material-symbols:location-on"}
                    />
                    Prairie View, TX
                  </div>
                  <div className="mb-2 flex gap-2 text-[#c1d1e7]">
                    <Iconify
                      classes="text-xl"
                      icon={"icon-park-solid:degree-hat"}
                    />
                    Bachelor Degree of Computer Science and Engineering
                  </div>
                </div>
                <div className="mt-4 flex flex-col gap-[3px]">
                  <div className="flex w-full flex-col gap-4 xl:flex-row">
                    <ListItem key={`edu-1`} paragraph={"Computer Science"} />
                    <ListItem
                      key={`edu-0`}
                      paragraph={"Software Engineering"}
                    />
                  </div>
                  <div className="flex w-full flex-col gap-4 xl:flex-row">
                    <ListItem key={`edu-2`} paragraph={"Operating System"} />
                    <ListItem
                      key={`edu-3`}
                      paragraph={"Foundations of Algorithms"}
                    />
                  </div>
                  <div className="flex w-full flex-col gap-4 xl:flex-row">
                    <ListItem key={`edu-4`} paragraph={"Design Pattern"} />
                    <ListItem
                      key={`edu-5`}
                      paragraph={"Artificial intelligence"}
                    />
                  </div>
                </div>
                {/* <div className="mt-10 flex justify-center">
                <Carousel>
                  {[...new Array(10)].map((_, i) => (
                    <Card
                      title={'Card ' + (i + 1)}
                      key={'carEdu' + i}
                      content="Lorem ipsum dolor sit amet mollit anim id est laborum."
                    />
                  ))}
                </Carousel>
              </div> */}
              </div>
            </div>
          </LoadAnimate>
        </section>
      </div>
    </>
  );
}
